import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { RedirectPageEnum, User } from '../../models/user/user.model';

@Component({
    selector: 'app-edit-user-dialog',
    templateUrl: './edit-user-dialog.component.html',
    styleUrls: ['./edit-user-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class EditUserDialogComponent implements OnInit {

    muTransRatePercent = 0;
    salesCommissPercent = 0;

    user: User;
    redirectPages: string[] = [];
    redirectPage: string;

    redirectDropdownOpen = false;
    saveDialogOpen = false;

    constructor(
        public dialogRef: MatDialogRef<EditUserDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: {
            user: User,
            orgIsSelfServiceReview: boolean
        }
    ) {

        this.user = this.data.user;

        if (this.user.defaultUserMarkup) {
            if (this.user.defaultUserMarkup.ratePerTrans) {
                this.muTransRatePercent = Number((this.user.defaultUserMarkup.ratePerTrans * 100).toFixed(3));
            }
        } else {
            this.user.defaultUserMarkup = {
                useInheritedValues: true,
                ratePerTrans: 0,
                costPerTrans: 0,
                fixedMonthlyFeeTotal: 0
            };
        }

        if (this.user.defaultUserCommission) {
            if (this.user.defaultUserCommission.salesCommissionPercent) {
                this.salesCommissPercent = Number((this.user.defaultUserCommission.salesCommissionPercent * 100).toFixed(3));
            }
        } else {
            this.user.defaultUserCommission = {
                useInheritedValues: true,
                salesCommissionPercent: 0
            };
        }


        for (const value in RedirectPageEnum)
            if (value !== 'IMPERSONATE'
                || (value === 'IMPERSONATE' && this.user.isAdmin))
                this.redirectPages.push(RedirectPageEnum[value]);

        if (this.user.redirectPage)
            this.redirectPage = this.user.redirectPage;
        else
            this.redirectPage = this.redirectPages[0];
    }

    ngOnInit(): void { }

    save() {
        this.user.defaultUserMarkup.ratePerTrans = this.muTransRatePercent ? Number((this.muTransRatePercent / 100).toFixed(6)) : 0;
        this.user.defaultUserCommission.salesCommissionPercent = this.salesCommissPercent ? Number((this.salesCommissPercent / 100).toFixed(6)) : 0;
        this.user.redirectPage = this.redirectPage.toLowerCase() as RedirectPageEnum;

        this.saveDialogOpen = true;
    }

    closeSaveDialog() {
        this.saveDialogOpen = false;
        this.dialogRef.close(this.user);
    }

}
